import { WorkerPool } from '@/plugins/pointCloud/core/WorkerPool'

/** 全局 Potree Worker 池单例 */
export const workerPool = new WorkerPool()

/** 当前 Potree 版本号，用于序列化兼容判断 */
export const version = {
  major: 1,
  minor: 8,
  suffix: '.0',
}

/** 全局默认点预算，上限 1 百万 */
export const pointBudget = 1 * 1000 * 1000
/** 当前进行中的节点加载数量（运行期统计） */
export const numNodesLoading = 0
/** 最大加载节点数 */
export const maxNodesLoading = 8
/** 是否启用性能耗时统计 */
export const measureTimings = false

/** 调试挂点对象，供外部写入临时变量 */
export const debug: any = {}
